import { render, staticRenderFns } from "./ForcePasswordChange.vue?vue&type=template&id=465459cc&scoped=true"
import script from "./ForcePasswordChange.vue?vue&type=script&lang=js"
export * from "./ForcePasswordChange.vue?vue&type=script&lang=js"
import style0 from "./ForcePasswordChange.vue?vue&type=style&index=0&id=465459cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465459cc",
  null
  
)

export default component.exports